module.exports = __webpack_public_path__ + "static/media/002.feb400d1.svg";